"use strict";

exports.__esModule = true;
exports.default = exports.Unwrapped = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _formik = require("formik");

var _Button = _interopRequireDefault(require("../../Button/Button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormikResetButton = function FormikResetButton(_ref) {
  var formik = _ref.formik,
      children = _ref.children;
  return _react.default.createElement(_Button.default, {
    type: "button",
    disabled: Boolean(!formik.dirty || formik.isSubmitting),
    onClick: formik.resetForm
  }, children);
};

exports.Unwrapped = FormikResetButton;
FormikResetButton.displayName = 'FormikResetButton';
FormikResetButton.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  formik: _propTypes.any.isRequired,
  children: _propTypes.string
};
FormikResetButton.defaultProps = {
  children: 'Reset'
};

/** @component */
var _default = (0, _formik.connect)(FormikResetButton);

exports.default = _default;